import { render, staticRenderFns } from "./LiquidityAssumptions.vue?vue&type=template&id=0f4b63d3&scoped=true"
import script from "./LiquidityAssumptions.vue?vue&type=script&lang=js"
export * from "./LiquidityAssumptions.vue?vue&type=script&lang=js"
import style0 from "./LiquidityAssumptions.vue?vue&type=style&index=0&id=0f4b63d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b63d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSlider,VTextField})
